import { useContext } from 'react'
import { EnrollmentContext } from '@contexts/EnrollmentContext'

export const useEnrollment = () => {
  return useContext(EnrollmentContext)
}
